import React from 'react';
import TradingView from './components/TradingView';

const Chart = () => {
  return (
    <div className="h-full w-full bg-[#000] relative">
      <TradingView />
    </div>
  );
};

export default Chart;
